import { useOrg } from "@/hooks/useOrg";
import { Button } from "@/components/ui/button";
import { Copy, Check } from "lucide-react";
import { useState } from "react";

export default function Embed() {
  const { orgId } = useOrg();
  const [copied, setCopied] = useState(false);

  const scriptTag = `<script src="https://embed.supportfyi.com?org=${orgId}" defer></script>`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(scriptTag);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="p-4 sm:p-8">
      <div className="mb-8">
        <h1 className="text-lg font-semibold text-foreground">Embed code</h1>
        <p className="text-sm text-muted-foreground">
          Add this single line to your website's HTML to display banners
        </p>
      </div>

      <div className="max-w-2xl space-y-4">
        <div className="relative rounded-lg border border-border bg-card p-4">
          <pre className="overflow-x-auto text-sm text-foreground">
            <code>{scriptTag}</code>
          </pre>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleCopy}
            className="absolute right-2 top-2"
          >
            {copied ? (
              <Check className="h-4 w-4" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
          </Button>
        </div>

        <div className="space-y-3 text-sm text-muted-foreground">
          <h3 className="font-medium text-foreground">Setup</h3>
          <ol className="list-decimal list-inside space-y-1.5">
            <li>Copy the script tag above</li>
            <li>
              Paste it in your website's{" "}
              <code className="rounded bg-muted px-1 py-0.5 text-xs">
                &lt;head&gt;
              </code>{" "}
              or before the closing{" "}
              <code className="rounded bg-muted px-1 py-0.5 text-xs">
                &lt;/body&gt;
              </code>{" "}
              tag
            </li>
            <li>Active banners will appear as a top bar on your site</li>
          </ol>
        </div>

        <div className="space-y-3 text-sm text-muted-foreground">
          <h3 className="font-medium text-foreground">Custom placement</h3>
          <p>
            If you'd like to place the banner in a custom location other than
            the top of the page, add a{" "}
            <code className="rounded bg-muted px-1 py-0.5 text-xs">
              &lt;div data-supportfyi-embed&gt;&lt;/div&gt;
            </code>{" "}
            element to your page and the banner will be rendered inside it.
          </p>
        </div>
      </div>
    </div>
  );
}
